module.exports = __webpack_public_path__ + "img/analytics-timeline@2x.0da18748.jpg";